export default __webpack_public_path__ + "locales/de/Common.json?hash=5d70946c3bd4dd262ad7aef1c86cf92e";